import type { TTab } from '@cian/ui-kit';
import { EUserCardTab } from './types';

export const USER_CARD_SWITCHER_TABS_CONFIG: Record<EUserCardTab, TTab> = {
  [EUserCardTab.About]: {
    text: 'О клиенте',
    dataTestId: 'chat|userCard|switcher|about',
  },
  [EUserCardTab.Photos]: {
    text: 'Фото',
    dataTestId: 'chat|userCard|switcher|photos',
  },
};
